import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";
import { AdminHeader, Modal, ConfirmDelete, EditBtn, AddBtn, Field } from "../../components/admin/AdminUI";

const empty = { name: "", specialization: "Ophthalmology", hospital: "", city: "Ghaziabad", photo: "", email: "", phone: "", membership_no: "", joined_year: 2024 };

export default function MembersAdmin() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/admin/members").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.type === "number" ? Number(e.target.value) : e.target.value });

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing) await api.put(`/admin/members/${editing}`, form);
      else await api.post("/admin/members", form);
      toast.success(editing ? "Updated" : "Created");
      setOpen(false); setForm(empty); setEditing(null); load();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
  };
  const edit = (m) => { setEditing(m.id); setForm({ ...empty, ...m }); setOpen(true); };
  const del = async (id) => { await api.delete(`/admin/members/${id}`); load(); toast.success("Deleted"); };

  const filtered = q ? items.filter((m) => (m.name + m.hospital + m.specialization).toLowerCase().includes(q.toLowerCase())) : items;

  return (
    <div>
      <AdminHeader title="Members Directory" subtitle={`${items.length} members`} actions={<AddBtn onClick={() => { setEditing(null); setForm(empty); setOpen(true); }} />} />
      <div className="mb-4"><input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search members…" className="form-input max-w-md" /></div>
      <div className="card-elev overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-brand-bg text-brand-muted text-xs uppercase tracking-wider">
            <tr><th className="px-4 py-3 text-left">Name</th><th className="px-4 py-3 text-left">Specialization</th><th className="px-4 py-3 text-left">Hospital</th><th className="px-4 py-3 text-left">City</th><th className="px-4 py-3 text-left">Mem. No.</th><th className="px-4 py-3 text-right">Actions</th></tr>
          </thead>
          <tbody className="divide-y divide-brand-border">
            {filtered.slice(0, 200).map((m) => (
              <tr key={m.id} className="hover:bg-brand-bg/50">
                <td className="px-4 py-3 font-semibold text-brand-text">{m.name}</td>
                <td className="px-4 py-3">{m.specialization}</td>
                <td className="px-4 py-3 text-brand-muted">{m.hospital}</td>
                <td className="px-4 py-3">{m.city}</td>
                <td className="px-4 py-3 text-brand-muted">{m.membership_no}</td>
                <td className="px-4 py-3 text-right"><div className="inline-flex items-center gap-1"><EditBtn onClick={() => edit(m)} /><ConfirmDelete onConfirm={() => del(m.id)} /></div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Modal open={open} onClose={() => setOpen(false)} title={editing ? "Edit Member" : "New Member"} size="lg">
        <form onSubmit={save} className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Name *"><input required value={form.name} onChange={upd("name")} className="form-input" /></Field>
          <Field label="Specialization"><input value={form.specialization} onChange={upd("specialization")} className="form-input" /></Field>
          <Field label="Hospital"><input value={form.hospital} onChange={upd("hospital")} className="form-input" /></Field>
          <Field label="City"><input value={form.city} onChange={upd("city")} className="form-input" /></Field>
          <Field label="Email"><input value={form.email} onChange={upd("email")} className="form-input" /></Field>
          <Field label="Phone"><input value={form.phone} onChange={upd("phone")} className="form-input" /></Field>
          <Field label="Membership No."><input value={form.membership_no} onChange={upd("membership_no")} className="form-input" /></Field>
          <Field label="Joined Year"><input type="number" value={form.joined_year} onChange={upd("joined_year")} className="form-input" /></Field>
          <div className="md:col-span-2 flex justify-end gap-2"><button type="button" onClick={() => setOpen(false)} className="btn-ghost">Cancel</button><button className="btn-primary">{editing ? "Update" : "Create"}</button></div>
        </form>
      </Modal>
    </div>
  );
}
